import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '@/views/Home.vue'
import Main from '@/views/Main.vue'
import Login from '@/views/Login.vue'
import Zoon from '@/views/Zoon.vue'
import Class from '@/views/Class.vue'
import Look from '@/views/Look.vue'
import User from '@/views/User.vue'
import ChangePwd from '@/views/ChangePwd.vue'
import CheckFile from '@/views/CheckFile.vue'


Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    // name: 'Home',
    component: Home,
    children: [
      {
        path: '',
        name: 'Main',
        component: Main
      },
      {
        name: 'Zoon',
        path: '/zoon:id',
        component: Zoon
      },
      {
        name: 'Class',
        path: '/class:id',
        component: Class
      },
      {
        name: 'Look',
        path: '/look:id',
        component: Look
      },
      {
        name: 'User',
        path: '/user',
        component: User
      },
      {
        name: 'ChangePwd',
        path: '/ChangePwd:username',
        component: ChangePwd
      },
      {
        name: 'CheckFile',
        path: '/CheckFile:course_id',
        component: CheckFile
      }

      
    ]
  },
  {
    path: '/login',
    name: 'Login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: Login
  }
]

const router = new VueRouter({
  routes
})

export default router
